"use client";

import { create } from "zustand";

interface SignalData<T = unknown> {
  data: T;
  timestamp: number;
}

interface SignalsStore {
  signals: Record<string | symbol, SignalData>;
  emit: <T>(name: string | symbol, data: T) => void;
}

/**
 * This is only used with `useSignal` hook. Reference `useSignal` for more information.
 */
export const useSignalsStore = create<SignalsStore>((set) => ({
  signals: {},

  emit: (name, data) => {
    set((state) => ({
      signals: {
        ...state.signals,
        [name as string | symbol]: { data, timestamp: Date.now() },
      },
    }));
  },
}));
